import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CreateDrillCommandPayload } from '../handlers';
import { DrillViewModel } from '../models';

@Injectable({ providedIn: 'root' })
export class DrillDraftStorage {
  private readonly copySeed$: BehaviorSubject<CreateDrillCommandPayload | null> =
    new BehaviorSubject<CreateDrillCommandPayload | null>(null);

  private readonly returnToPlanRequested$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private readonly lastCreated$: BehaviorSubject<DrillViewModel | null> = new BehaviorSubject<DrillViewModel | null>(
    null
  );

  setCopySeed(seed: CreateDrillCommandPayload): void {
    this.copySeed$.next(seed);
  }

  takeCopySeed(): CreateDrillCommandPayload | null {
    const seed: CreateDrillCommandPayload | null = this.copySeed$.value;
    if (seed !== null) {
      this.copySeed$.next(null);
    }
    return seed;
  }

  requestReturnToPlan(): void {
    this.returnToPlanRequested$.next(true);
  }

  takeReturnToPlanRequested(): boolean {
    const requested: boolean = this.returnToPlanRequested$.value;
    if (requested) {
      this.returnToPlanRequested$.next(false);
    }
    return requested;
  }

  setLastCreated(drill: DrillViewModel): void {
    this.lastCreated$.next(drill);
  }

  takeLastCreated(): DrillViewModel | null {
    const drill: DrillViewModel | null = this.lastCreated$.value;
    if (drill !== null) {
      this.lastCreated$.next(null);
    }
    return drill;
  }
}
